import actions from '@/store/albums/actions';
import types from '@/store/albums/types';

const albumsModule = {
  state: () => ({
    templates: [],
    currentTemplate: null,
    isLoading: false,
    error: null,
  }),
  mutations: {
    [types.GET_TEMPLATES_START](state) {
      state.isLoading = true;
      state.error = null;
    },
    [types.GET_TEMPLATES_SUCCESS](state, data) {
      state.templates = data;
      state.isLoading = false;
      state.error = null;
    },
    [types.GET_TEMPLATES_FAILURE](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [types.GET_TEMPLATE_START](state) {
      state.isLoading = true;
      state.error = null;
    },
    [types.GET_TEMPLATE_SUCCESS](state, data) {
      state.currentTemplate = data;
      state.isLoading = false;
      state.error = null;
    },
    [types.GET_TEMPLATE_FAILURE](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [types.CREATE_TEMPLATE_START](state) {
      state.isLoading = true;
      state.error = null;
    },
    [types.CREATE_TEMPLATE_SUCCESS](state, data) {
      state.templates.push(data);
      state.isLoading = false;
      state.error = null;
    },
    [types.CREATE_TEMPLATE_FAILURE](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [types.UPDATE_TEMPLATE_START](state) {
      state.isLoading = true;
      state.error = null;
    },
    [types.UPDATE_TEMPLATE_SUCCESS](state, updatedTemplate) {
      const index = state.templates.findIndex((t) => t.id === updatedTemplate.id);
      if (index !== -1) {
        state.templates.splice(index, 1, updatedTemplate);
      }
      state.isLoading = false;
      state.error = null;
    },
    [types.UPDATE_TEMPLATE_FAILURE](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [types.DELETE_TEMPLATE_START](state) {
      state.isLoading = false;
      state.error = null;
    },
    [types.DELETE_TEMPLATE_SUCCESS](state, templateId) {
      state.templates = state.templates.filter((t) => t.id !== templateId);
      state.isLoading = false;
      state.error = null;
    },
    [types.DELETE_TEMPLATE_FAILURE](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [types.CLEAR_ERROR](state) {
      state.error = null;
    },
  },
  actions,
  namespaced: true,
};

export default albumsModule;
